const CARD_PATH = new Path2D(
	"M31.44 0H2.78C1.24 0 0 1.24 0 2.78V32.90C0 34.43 1.24 35.67 2.78 35.67H18.61C19.46 35.67 20.26 35.29 20.78 34.62C21.31 33.95 22.11 33.56 22.96 33.56H31.44C32.97 33.56 34.22 32.32 34.22 30.78V2.78C34.22 1.24 32.97 0 31.44 0Z"
);
const DOT_X = [10.0, 13.56, 17.11, 20.66, 24.2];
const DOT_Y = [10.74, 14.26, 17.78, 21.31, 24.83];
const DOT_R = 1.26;
const CARD_SCALE = 1.3;
const CHECK = [
	[0, 2],
	[1, 3],
	[2, 2],
	[3, 1],
	[4, 0],
];
const PERIMETER = [
	[0, 0], [1, 0], [2, 0], [3, 0], [4, 0],
	[4, 1], [4, 2], [4, 3], [4, 4],
	[3, 4], [2, 4], [1, 4], [0, 4],
	[0, 3], [0, 2], [0, 1],
];
const PERI_LEN = 16;
const LAPS = 2;

function easeOutCubic(t) {
	return 1 - Math.pow(1 - t, 3);
}
function easeInOutQuad(t) {
	return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

// Durées de la cascade d'une carte étiquette (secondes), cf. concept.
export function etiqTimeline(sweepDur) {
	const T1 = 0.55;
	const T2 = T1 + 0.6;
	const T3 = T2 + sweepDur;
	const T3F = T3 + 0.3;
	const T3A = T3F + 0.5;
	const T3B = T3A + 0.6;
	const T3C = T3B + 0.5;
	const T4 = T3C + 0.6;
	const T5 = T4 + 0.4;
	const T6 = T5 + 0.9;
	return { T1, T2, T3, T3F, T3A, T3B, T3C, T4, T5, T6 };
}

export default class HomeBannerAnnotations {
	constructor(canvas) {
		this.canvas = canvas;
		this.ctx = canvas.getContext("2d");
		this.tickLen = 10;

		// Cycle des cartes étiquette — scène 1 (plusieurs cartes en rotation)
		this.animStartMs = null;
		this.currentOrder = null;
		this.barData = null;
		this.cycleStartS = 0;

		// Carte étiquette — scène 2 (une seule carte active à la fois)
		this.animStartMs2 = null;
		this.barData2 = null;
	}

	resize(width, height) {
		// Plafonné à 2 : canvas 2D plein écran effacé et redessiné à chaque frame, au-delà le
		// coût grimpe sans gain de netteté visible sur les libellés.
		const dpr = Math.min(window.devicePixelRatio || 1, 2);
		this.width = width;
		this.height = height;
		this.canvas.width = Math.round(width * dpr);
		this.canvas.height = Math.round(height * dpr);
		this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	}

	clear() {
		this.ctx.save();
		this.ctx.setTransform(1, 0, 0, 1, 0, 0);
		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		this.ctx.restore();
	}

	projectToScreen(worldPos, camera) {
		const p = worldPos.clone();
		p.project(camera);
		return {
			x: (p.x * 0.5 + 0.5) * this.width,
			y: (-p.y * 0.5 + 0.5) * this.height,
			behind: p.z > 1,
		};
	}

	startCard1Cycle() {
		if (this.animStartMs === null) this.animStartMs = performance.now();
	}

	startCard2(barCount = 1) {
		this.animStartMs2 = performance.now();
		this.barData2 = HomeBannerAnnotations.newBarHeights(barCount);
	}

	resetCard2() {
		this.animStartMs2 = null;
		this.barData2 = null;
	}

	static newBarHeights(n) {
		return Array.from({ length: n }, () => Array.from({ length: 5 }, () => 1 + Math.floor(Math.random() * 5)));
	}

	static newShuffle(n, avoidFirst = -1) {
		const arr = Array.from({ length: n }, (_, i) => i);
		for (let i = n - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[arr[i], arr[j]] = [arr[j], arr[i]];
		}
		if (avoidFirst >= 0 && arr[0] === avoidFirst && n > 1) {
			const swapIdx = 1 + Math.floor(Math.random() * (n - 1));
			[arr[0], arr[swapIdx]] = [arr[swapIdx], arr[0]];
		}
		return arr;
	}

	drawAltitudePoints(points, camera, parallaxGroup, annotReveal, time) {
		if (!points.length) return;
		const ctx = this.ctx;
		const color = "#5B7BFF";
		const fontSize = 11;
		const speed = 0.3;
		const STAGGER_DELAY = 0.18;
		const FADE_DUR = 0.55;
		const LINE_DUR = 0.4;

		points.forEach((pt) => {
			const worldPos = pt.localPos.clone();
			parallaxGroup.localToWorld(worldPos);
			const sc = this.projectToScreen(worldPos, camera);
			if (sc.behind) {
				pt.alpha = 0;
				pt.lineProgress = 0;
				return;
			}

			const startThreshold = (pt.revealOrder * STAGGER_DELAY * points.length) / 2.5;
			const localReveal = Math.max(0, annotReveal - startThreshold / 2.5);
			const targetAlpha = Math.min(localReveal / FADE_DUR, 1);
			const targetLine = Math.min(localReveal / LINE_DUR, 1);

			pt.alpha += (targetAlpha - pt.alpha) * 0.18;
			pt.lineProgress += (targetLine - pt.lineProgress) * 0.14;
			if (pt.alpha < 0.01) return;

			const x = sc.x;
			const y = sc.y;
			const lh = pt.lineH;
			const s = pt.side;
			const p = pt.lineProgress;
			const drift = Math.sin(time * speed + pt.phase) * 3.7 + Math.sin(time * speed * 0.4 + pt.phase + 1.2) * 1.1;
			const val = pt.baseAlt + drift;
			const label = val.toFixed(1).replace(".", ",");

			ctx.globalAlpha = pt.alpha;
			ctx.strokeStyle = color;
			ctx.fillStyle = color;
			ctx.lineWidth = 1;
			ctx.font = `400 ${fontSize}px 'IBM Plex Mono', monospace`;

			ctx.beginPath();
			ctx.arc(x, y, 2, 0, Math.PI * 2);
			ctx.fill();

			const lineTop = y - lh * p;
			ctx.beginPath();
			ctx.moveTo(x, y - 3);
			ctx.lineTo(x, lineTop);
			if (p > 0.85) {
				const tickFade = Math.min((p - 0.85) / 0.15, 1);
				ctx.globalAlpha = pt.alpha * tickFade;
				ctx.lineTo(x + this.tickLen * s * tickFade, lineTop);
			}
			ctx.stroke();

			if (p > 0.9) {
				const textFade = Math.min((p - 0.9) / 0.1, 1);
				ctx.globalAlpha = pt.alpha * textFade;
				ctx.textAlign = s === 1 ? "left" : "right";
				ctx.textBaseline = "middle";
				const textX = x + (this.tickLen + 4) * s;
				const tw = ctx.measureText(label).width;
				const padX = 5;
				const padY = 3;
				const br = 3;
				const bgX = s === 1 ? textX - padX : textX - tw - padX;
				const bgY = lineTop - fontSize / 2 - padY;

				ctx.fillStyle = "white";
				ctx.beginPath();
				ctx.roundRect(bgX, bgY, tw + padX * 2, fontSize + padY * 2, br);
				ctx.fill();

				ctx.fillStyle = color;
				ctx.fillText(label, textX, lineTop);
			}
		});
		ctx.globalAlpha = 1;
	}

	drawCard(cx, cy, globalAlpha, elapsed, timeline, laps, barRow) {
		const ctx = this.ctx;
		const { T1, T2, T3, T3F, T3A, T3B, T3C } = timeline;
		const s = CARD_SCALE;

		ctx.save();
		ctx.globalAlpha = globalAlpha;
		ctx.translate(cx, cy);
		ctx.scale(s, s);
		ctx.fillStyle = "#00FCD9";
		ctx.fill(CARD_PATH);

		if (elapsed >= T1) {
			const rippleE = elapsed - T1;
			const maxDist = Math.sqrt(8);
			const inRipple = elapsed < T2;
			const inSweep = elapsed >= T2 && elapsed < T3;
			const inSweepFade = elapsed >= T3 && elapsed < T3F;
			const inChartIn = elapsed >= T3F && elapsed < T3A;
			const inChartHld = elapsed >= T3A && elapsed < T3B;
			const inChartOut = elapsed >= T3B && elapsed < T3C;
			const inChart = inChartIn || inChartHld || inChartOut;
			const inCheck = elapsed >= T3C;

			const sweepHead = inSweep
				? ((elapsed - T2) / (T3 - T2)) * (laps * PERI_LEN)
				: inSweepFade
				? laps * PERI_LEN
				: -1;
			const bandSize = inSweep
				? Math.min(5, 1 + Math.floor(Math.min(sweepHead, 4)))
				: inSweepFade
				? Math.max(0, Math.ceil(5 * (1 - (elapsed - T3) / (T3F - T3))))
				: 5;
			const checkProgress = inCheck ? Math.min((elapsed - T3C) / (timeline.T4 - T3C), 1) : 0;
			const easedCheck = easeInOutQuad(checkProgress);

			for (let row = 0; row < 5; row++) {
				for (let col = 0; col < 5; col++) {
					const dist = Math.sqrt((col - 2) ** 2 + (row - 2) ** 2);
					const dotDelay = inRipple ? (dist / maxDist) * ((T2 - T1) * 0.3) : 0;
					const dotA = inRipple ? Math.min(Math.max((rippleE - dotDelay) / 0.2, 0), 1) : 1;
					if (dotA <= 0) continue;

					let dr = 255;
					let dg = 255;
					let db = 255;
					let da = dotA;

					if ((inSweep || inSweepFade) && sweepHead >= 0 && bandSize > 0) {
						const pi = PERIMETER.findIndex(([pc, pr]) => pc === col && pr === row);
						if (pi !== -1) {
							const head = sweepHead % PERI_LEN;
							const behind = (head - pi + PERI_LEN) % PERI_LEN;
							if (behind < bandSize) {
								dr = 0;
								dg = 29;
								db = 252;
								da = 1;
							}
						}
					} else if (inChart) {
						const barH = barRow ? barRow[col] : 3;
						let dotsLit;
						if (inChartIn) {
							const e = elapsed - T3F;
							const colP = easeOutCubic(Math.max(0, Math.min((e - col * 0.06) / 0.26, 1)));
							dotsLit = Math.floor(colP * barH);
						} else if (inChartHld) {
							dotsLit = barH;
						} else {
							const e = elapsed - T3B;
							const p = easeInOutQuad(e / (T3C - T3B));
							dotsLit = Math.max(0, Math.round((1 - p) * barH));
						}
						if (4 - row < dotsLit) {
							dr = 0;
							dg = 29;
							db = 252;
						}
					} else if (inCheck) {
						const ci = CHECK.findIndex(([cc, cr]) => cc === col && cr === row);
						if (ci !== -1 && easedCheck > ci / CHECK.length) {
							dr = 0;
							dg = 29;
							db = 252;
						}
					}

					ctx.fillStyle = `rgba(${dr},${dg},${db},${da.toFixed(2)})`;
					ctx.beginPath();
					ctx.arc(DOT_X[col], DOT_Y[row], DOT_R, 0, Math.PI * 2);
					ctx.fill();
				}
			}
		}

		ctx.restore();
		ctx.globalAlpha = 1;
	}

	// Scène 1 — plusieurs cartes en rotation aléatoire au-dessus des points "etiquette*"
	drawEtiquettes(points, camera, parallaxGroup, time, yOffsets = [-60, -60, 20]) {
		const n = points.length;
		if (!n || this.animStartMs === null) return;
		const globalElapsed = (performance.now() - this.animStartMs) / 1000;
		const timeline = etiqTimeline(3.0);
		const { T1, T5, T6 } = timeline;
		const cycleDur = n * T6;

		if (this.currentOrder === null) {
			this.currentOrder = HomeBannerAnnotations.newShuffle(n);
			this.barData = HomeBannerAnnotations.newBarHeights(n);
			this.cycleStartS = 0;
		}
		while (globalElapsed - this.cycleStartS >= cycleDur) {
			this.cycleStartS += cycleDur;
			const lastCard = this.currentOrder[this.currentOrder.length - 1];
			this.currentOrder = HomeBannerAnnotations.newShuffle(n, lastCard);
			this.barData = HomeBannerAnnotations.newBarHeights(n);
		}
		const localElapsed = globalElapsed - this.cycleStartS;

		this.currentOrder.forEach((originalIdx, slotIdx) => {
			const point = points[originalIdx];
			const worldPos = point.localPos.clone();
			parallaxGroup.localToWorld(worldPos);
			const sc = this.projectToScreen(worldPos, camera);
			if (sc.behind) return;

			const elapsed = localElapsed - slotIdx * T6;
			if (elapsed < 0 || elapsed > T6) return;

			const introP = easeOutCubic(Math.min(elapsed / T1, 1));
			const introOffset = (1 - introP) * 16;
			const outroRaw = elapsed > T5 ? Math.min((elapsed - T5) / (T6 - T5), 1) : 0;
			const outroP = easeInOutQuad(outroRaw);
			const outroOffset = outroP * 6;

			const s = CARD_SCALE;
			const cx = sc.x - (34.22 * s) / 2;
			const yOff = yOffsets[originalIdx] ?? -60;
			const cy = sc.y - (35.67 * s) / 2 + yOff + introOffset + outroOffset;

			this.drawCard(cx, cy, introP * (1 - outroP), elapsed, timeline, LAPS, this.barData[slotIdx]);
		});
	}

	// Scène 2 — une seule carte active, au-dessus du bâtiment en cours de "scan"
	drawEtiquette2(localPos, camera, parallaxGroup, sceneFadeIn, laps2 = 2, yOffset = -65) {
		if (!localPos || this.animStartMs2 === null) return;
		const elapsed = (performance.now() - this.animStartMs2) / 1000;
		const sweepDur2 = 3.0 * (laps2 / LAPS);
		const timeline = etiqTimeline(sweepDur2);
		const { T1, T5, T6 } = timeline;
		if (elapsed < 0 || elapsed > T6) return;

		const worldPos = localPos.clone();
		parallaxGroup.localToWorld(worldPos);
		const sc = this.projectToScreen(worldPos, camera);
		if (sc.behind) return;

		const introP = easeOutCubic(Math.min(elapsed / T1, 1));
		const introOffset = (1 - introP) * 16;
		const outroRaw = elapsed > T5 ? Math.min((elapsed - T5) / (T6 - T5), 1) : 0;
		const outroP = easeInOutQuad(outroRaw);
		const outroOffset = outroP * 6;

		const s = CARD_SCALE;
		const cx = sc.x - (34.22 * s) / 2;
		const cy = sc.y - (35.67 * s) / 2 + yOffset + introOffset + outroOffset;

		this.drawCard(cx, cy, introP * (1 - outroP) * sceneFadeIn, elapsed, timeline, laps2, this.barData2 ? this.barData2[0] : null);
	}

	isCard2CycleDone(laps2 = 2) {
		if (this.animStartMs2 === null) return false;
		const sweepDur2 = 3.0 * (laps2 / LAPS);
		const { T6 } = etiqTimeline(sweepDur2);
		return (performance.now() - this.animStartMs2) / 1000 >= T6;
	}
}
